import { useCallback, useEffect, useRef } from "react";
import { IModalProps } from "./Modal.interface";
import Button from "../Button/Button";

function Modal({ isOpen, setIsOpen, title, children, customCss, style }: IModalProps) {
    const modal = useRef<HTMLDialogElement>(null);

    const closeModal = useCallback(() => {
        modal.current?.close();

        if (document.querySelectorAll("dialog[open]").length > 0) return;
        document.documentElement.classList.remove("overflow-hidden");
    }, [modal]);

    const openModal = useCallback(() => {
        modal.current?.showModal();
        document.documentElement.classList.add("overflow-hidden");
    }, [modal]);

    useEffect(() => {
        if (isOpen) openModal();
        else closeModal();
    }, [isOpen]);

    useEffect(() => {
        const observer = new MutationObserver(() =>
            setIsOpen ? setIsOpen(modal.current?.open ?? false) : null
        );
        observer.observe(modal.current as Node, { attributes: true });
    }, [modal, setIsOpen]);

    return (
        <dialog ref={modal} className={`modal ${customCss ?? ""}`} style={style}>
            <div className="modal_header d-flex align-items-start justify-content-between">
                <span className="text-bd1-smbd">{title}</span>
                <Button
                    type="button"
                    icon="Close"
                    onClick={() => (setIsOpen ? setIsOpen((v) => !v) : closeModal())}
                />
            </div>
            <div className="modal_body">{children}</div>
        </dialog>
    );
}

export default Modal;
